import React from "react";
import { Img } from "components/Img";

const TemplateMedaiActionCard = ({
  element,
  handleOpenDrawer,
  disableAddPhotos = false,
}) => {
  const getImageUrl = (imageObj) => {
    if (!imageObj) return null;
    return (
      imageObj.selectedImage ||
      imageObj.orignalImage ||
      imageObj.originalImage ||
      imageObj.image ||
      imageObj.image_url ||
      null
    );
  };

  const renderImageGrid = () => {
    return (
      <div className="grid grid-cols-5 gap-2 relative">
        {element.MEDIA.map((imageObj, index) => {
          const imageUrl = getImageUrl(imageObj);

          return imageUrl ? (
            <div key={index} className="aspect-video w-full">
              <Img
                src={imageUrl}
                alt={`Campus image ${index + 1}`}
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          ) : null;
        })}
      </div>
    );
  };

  return (
    <div className="w-full mb-2">
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div className="flex items-center justify-between p-4 border-b">
          <span className="text-[2vh] text-gray-700 font-medium">
            {element.IMAGE_FOR}
          </span>
          {!disableAddPhotos && (
            <button
              onClick={handleOpenDrawer}
              className="text-indigo-600 text-[2vh] font-medium"
              type="button"
            >
              {element.MEDIA?.length < 5 ? "Add photos" : "Edit"}
            </button>
          )}
        </div>

        {element.MEDIA && element.MEDIA.length > 0 && (
          <div className="p-4">{renderImageGrid()}</div>
        )}
      </div>
    </div>
  );
};

export default TemplateMedaiActionCard;
